import axios from 'axios';
import { http } from '../../jobs/api/http';
import { API } from '../../../config/api';

export async function fetchOperatorSummary() {
  const { data } = await http.get('/api/redis/operator-dashboard/summary');
  return data;
}

export async function fetchOperatorMaterials() {
  const { data } = await http.get('/api/redis/operator-dashboard/materials');
  return data;
}

export async function fetchOperatorTokens(filters = {}) {
  const params = {};
  // Only send the filters that are set — an empty string would match nothing.
  for (const key of ['phase', 'operator', 'machineId', 'status']) {
    if (filters[key]) params[key] = filters[key];
  }
  const { data } = await http.get('/api/redis/operator-dashboard/tokens', { params });
  return data;
}

export async function fetchOperatorLive() {
  const { data } = await http.get('/api/redis/operator-dashboard/live');
  return data;
}

// The roster lives in eng-backend, not the jobs service — the live endpoint is
// deliberately Redis-only so it keeps working when the users service is down.
export async function fetchOperatorRoster() {
  const { data } = await axios.get(`${API.BACKEND}/api/v1/operators`);
  return data?.data || data || [];
}

export async function fetchOperatorDowntime(days = 30) {
  const { data } = await http.get('/api/redis/operator-dashboard/downtime', {
    params: { days }
  });
  return data;
}
